import React, { Fragment, useEffect } from 'react'
import { useLocation, useParams } from 'react-router-dom'
import Header from '../components/layouts/Header';
import Footer from '../components/layouts/Footer';
import TechHire from '../features/tech_hire/TechHire';
import { useDispatch, useSelector } from 'react-redux';
import { fetchDeveloperByRoleOrSkill, fetchFaqsByRoleOrSkill } from '../redux/action/homeAction';
import useDocumentTitle from '../hooks/useDocumentTitle';
import useCanonical from '../hooks/useCanonical';
import StaticMetaData from '../constants/StaticMetaData';

const SkillOrRole = () => {
    useDocumentTitle("Hire Developer");

    const { slug } = useParams();
    const dispatch = useDispatch()
    const location = useLocation()

    const {tech, spec} = useSelector(state => state.common)

    const faqParams = location.pathname.includes("skill") ? `skills/${slug}/` : `specializations/${slug}/`
    const params = location.pathname.includes("skill") ? `skills=${slug}` : `specialization__slug=${slug}`
    
    // Generate canonical URL based on current path
    const canonicalTag = useCanonical(location.pathname);    

    useEffect(() => {
        dispatch(fetchDeveloperByRoleOrSkill(params))
        dispatch(fetchFaqsByRoleOrSkill(faqParams))
        setTitleAndDescription()
        // eslint-disable-next-line
    }, [slug, tech, spec]);

    const setTitleAndDescription = () => {
        if(location.pathname.includes("skill")) {
            const technology = tech.technologies.find(t => t.slug === slug)
            try {
                document.title = StaticMetaData[slug].title;
                document.querySelector('meta[name="description"]').setAttribute('content', StaticMetaData[slug].description);
            }
            catch (error) {            
                document.title = `${technology?.name} Developer | Dev Hire`;
                document.querySelector('meta[name="description"]').setAttribute('content', `Hire ${technology?.name} developers with Dev Hire. Get top-tier remote developers for your projects. Flexible contracts, risk-free trials, and expert support.`)
            }
        } else {
            const specialization = spec.specializationList.find(s => s.slug === slug)

            try {
                document.title = StaticMetaData[slug].title;
                document.querySelector('meta[name="description"]').setAttribute('content', StaticMetaData[slug].description);
            }
            catch (error) {
                document.title = `${specialization?.name} Developer | Dev Hire`;
                document.querySelector('meta[name="description"]').setAttribute('content', `Hire ${specialization?.name} developers with Dev Hire. Get top-tier remote developers for your projects. Flexible contracts, risk-free trials, and expert support.`)
            }
        }
    }

    return (
        <Fragment>
            {canonicalTag}
            <Header />
            <TechHire />
            <Footer />
        </Fragment>
    )
}

export default SkillOrRole;